import React from 'react'
import { useIntl } from 'react-intl'
import {
  Headline,
  ImageText,
  RecommendationCarousel,
  DynamicTag,
  Accordion,
  AccordionItem
} from 'msp-components'
import { findImageGroupBy } from 'msp-integrations'
import useProduct from '@/hooks/use-product'
import ProductTile from '../ProductTile/ProductTile'
import { ProductSetDetailsProps } from './ProductSetDetails.types'

const ProductSetDetails = ({
  product,
  bgStyle,
  imagePosition,
  contentPosition,
  defaultImage,
  className
}: ProductSetDetailsProps) => {
  const { formatMessage } = useIntl()
  const productSet = useProduct(product.id, true)
  const setProducts = productSet?.setProducts?.filter((product) => product.id)

  const accordionItemList: AccordionItem[] = []
  const idToImageMapping = new Map()

  setProducts?.map((itemRow: any, index) => {
    const largeImageGroup = findImageGroupBy(itemRow.imageGroups, {
      viewType: 'large',
      selectedVariationAttributes: itemRow?.variationValues || {}
    })

    const description = `<b>${formatMessage({
      id: 'msp.product.properties.ingredients',
      defaultMessage: 'Ingredients'
    })}:</b> ${itemRow?.c_ingredients}`

    accordionItemList.push({
      id: itemRow.id,
      headlineIndex: index + 1,
      headline: itemRow?.name,
      imagePath: largeImageGroup?.images?.[0]?.disBaseLink,
      contentText: description
    })

    idToImageMapping.set(
      itemRow.id,
      largeImageGroup?.images?.[0]?.disBaseLink || defaultImage
    )
  })

  return (
    <div className={className}>
      <div>
        <ImageText
          background={bgStyle}
          imagePosition={imagePosition}
          imageUrl={product?.c_contentImage}
          imageAlt={product?.name}
          contentPosition={contentPosition}
        >
          <div className='h-full'>
            {product?.c_teaDescription2Headline && (
              <Headline tag='h3' className='mb-6'>
                {product?.c_teaDescription2Headline}
              </Headline>
            )}
            {product?.c_teaDescription2 && (
              <span
                className='font-Roboto text-16 tracking-0 font-thin'
                dangerouslySetInnerHTML={{
                  __html: product?.c_teaDescription2.replace(/\r\n/g, '<br/>')
                }}
              />
            )}
          </div>
        </ImageText>
      </div>
      {product?.c_setItemQuantities?.length && (
        <div className='m-auto w-full max-w-[1700px] py-4 pl-4 md:mt-20'>
          <DynamicTag componentTagName='Headline' tag='h3' className='mb-6'>
            {formatMessage({
              id: 'msp.productset.products.title',
              defaultMessage: 'The set contains the following products:'
            })}
          </DynamicTag>
          <RecommendationCarousel
            hideArrows={false}
            hideControl={false}
            hideIndicators={false}
            productTiles={product.c_setItemQuantities
              .filter((item) => item.productId)
              .map((product) => (
                <ProductTile
                  key={`product-set-item-${product.productId}`}
                  data={{ productId: product.productId }}
                />
              ))}
          />
        </div>
      )}
      <div className='mt-10 w-full md:mt-20'>
        {setProducts && (
          <Accordion
            defaultOpenAccordionImage={defaultImage}
            accordionItems={accordionItemList}
            idToImageMapping={idToImageMapping}
            bgStyle={'jasmin_lightGreen'}
            accordionHeadline={formatMessage({
              id: 'msp.product.benefits.title',
              defaultMessage: 'Ingredients'
            })}
            imagePosition={'left'}
          />
        )}
      </div>
    </div>
  )
}

export default ProductSetDetails
